import angular from 'angular';
import uiRouter from 'angular-ui-router';
import businessDetailsComponent from './business-details.component';

let businessDetailsModule = angular.module('app.containers.business-details', [

])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('businessDetails', {
      url: '/businesses/:businessId',
      template: '<business-details></business-details>'
    });
})

.component('businessDetails', businessDetailsComponent);

export default businessDetailsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/business-details/business-details.js
 **/